module.exports = __webpack_public_path__ + "static/img/3791_phase_function_Paper_Points.889023d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3791_phase_function_Paper_Points.png
// module id = Ja7b
// module chunks = 0